export const CHART_SETTINGS_STORAGE_KEYS = {
  CORE: 'mt6_chart_settings_core'
} as const;
